import React, { useEffect } from 'react';
import { Card } from '@material-ui/core';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CreateRootMovieForm from './CreateRootMovieForm';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { findProfessions, getGenre, getMovieInfo, getProfessionsList } from 'redux/actions/Movies';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 50,
  },
}));

const CreateRootMovie = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const movieId = params.get('movie');

  const { movieInfo } = useSelector(({ movies }) => movies);

  useEffect(() => {
    if (movieId) {
      dispatch(getMovieInfo(movieId))
    }
    dispatch(findProfessions(''));
    dispatch(getGenre())
    dispatch(getProfessionsList())
  }, [dispatch, movieId])

  return (
    <PageContainer heading={movieInfo ? `مدیریت فیلم ${movieInfo?.movie_name}` : 'ساخت فیلم'}>
      <Card className={classes.cardRoot}>
        <CreateRootMovieForm movieInfo={movieInfo} />
      </Card>
    </PageContainer>
  );
};

export default CreateRootMovie;
